import { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { sdk } from '@/services/sdk';
import { PageHeader } from '@/components/kit';
import { BackLink } from '@/components/record';
import OrderForm, { blankOrder } from '@/components/admin/OrderForm';
import { committed, logActivity } from '@/shared/data';

export const route = { path: '/admin/orders/new', layout: 'owner', access: "['Admin_c','Staff_c'].includes(profile)" };

export default function NewOrder() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const customer = params.get('customer');
  const [initial] = useState(() => blankOrder(customer));
  const [saving, setSaving] = useState(false);
  const backTo = customer ? `/admin/customers/${customer}` : '/admin/orders';

  async function create(payload) {
    setSaving(true);
    try {
      const res = await sdk.table('orders_c').create(payload);
      const saved = committed(res, 'Order created');
      if (!saved) return;
      logActivity('Order', `Created ${payload.Name}`, payload.Name, payload.email_c);
      navigate(saved.Id ? `/admin/orders/${saved.Id}` : '/admin/orders');
    } finally {
      setSaving(false);
    }
  }

  return (
    <div className="mx-auto max-w-6xl">
      <BackLink to={backTo} label={customer ? 'Back to Customer' : 'Back to Orders'} />
      <PageHeader
        eyebrow="Orders"
        title="New order"
        description="Take an order by hand: from a DM, a call or a returning customer. The price is suggested from the plan."
      />
      <OrderForm
        initial={initial}
        onSubmit={create}
        saving={saving}
        submitLabel="Create order"
        busyLabel="Creating…"
        cancelTo={backTo}
      />
    </div>
  );
}
